import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { hexWithOpacity } from 'common/utils';
import { colors } from 'styles/colors';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    flex: 1,
  },
  resultItem: {
    border: `1px solid ${colors.itemBorder}`,
    borderRadius: '10px',
    marginBottom: '10px',
    cursor: 'pointer',
    paddingLeft: '10px',
    '&:hover': {
      backgroundColor: hexWithOpacity(colors.primary, 0.1),
    },
  }

}));

export default useStyles;
